/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
export const GET_FAMILY_PLANNING_DRUGS_INV_SEARCH_OBJ =
  'GET_FAMILY_PLANNING_DRUGS_INV_SEARCH_OBJ';
export const IS_LOADING = 'IS_LOADING';
export const GET_PLAN_TYPE_DATA = 'GET_PLAN_TYPE_DATA';
export const REFRESH_FAMILY_PLANNING_DRUGS_INV_DISPLAY =
  'REFRESH_FAMILY_PLANNING_DRUGS_INV_DISPLAY';
export const GET_ERROR_MSG_FAMILY_PLANNING_DRUGS_INV =
  'GET_ERROR_MSG_FAMILY_PLANNING_DRUGS_INV';
export const SET_FAMILY_PLANNING_DRUGS_INV_DETAIL =
  'SET_FAMILY_PLANNING_DRUGS_INV_DETAIL';
export const SET_DISPLAY_OBJ_FAMILY_INV = 'SET_DISPLAY_OBJ_FAMILY_INV';
export const DISPATCH_QTR_VALUE = 'DISPATCH_QTR_VALUE';
export const SET_REBATE_PROGRAM = 'SET_REBATE_PROGRAM';
export const REFRESH_FAMILY_PLANNING_DRUGS_INV =
  'REFRESH_FAMILY_PLANNING_DRUGS_INV';
